import dynamic from 'next/dynamic';
import { type ReactNode, useEffect, useState } from 'react';
import { AVAILABLE_THEMES, AVAILABLE_THEMES_TYPE, COLORS } from 'styles/constants';
import { LiquidButton } from '../../../../LiquidButton';
import { ButtonFlexContainer, Container, StyledSubmitButton } from '../../../styles';
import type { ISubmitButton } from '../../types';
import { useGlobalContext } from '@/components/Context/hooks/useGlobalContext';
const FriendlyCaptcha = dynamic(
  () => import('../../../Common/components/FriendlyCaptcha').then((mod) => mod.FriendlyCaptcha),
  {
    ssr: false,
  },
);

export const SubmitButton = ({
  field,
  formikProps,
  onCaptchaSuccess,
}: {
  field: ISubmitButton;
  formikProps: any;
  onCaptchaSuccess?: (solution: string) => void;
}): ReactNode => {
  const [isClient, setIsClient] = useState(false);
  const { themeName } = useGlobalContext();

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      {!!onCaptchaSuccess && isClient && (
        <>
          <FriendlyCaptcha
            onSuccess={(solution) => {
              onCaptchaSuccess(solution);
            }}
          />
        </>
      )}
      <Container>
        <ButtonFlexContainer>
          <StyledSubmitButton type="submit">
            <LiquidButton
              text={field.buttonText}
              variant={themeName === AVAILABLE_THEMES.suprema ? 'primary' : 'none'}
              className="submit-button"
              disabled={formikProps.isSubmitting}
              data-test={`submit-${field.buttonText}`}
              width={240}
              height={52}
              color={COLORS.primary}
              textColor={COLORS.white}
            />
          </StyledSubmitButton>
        </ButtonFlexContainer>
      </Container>
    </>
  );
};
